import { NumericFormat } from "react-number-format";

type PercentInputProps = {
  error?: any;
  values?: any;
  label?: string;
  name?: string;
  placeholder?: string;
  important?: boolean;
  readOnly?: boolean;
  classNames?: string;
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  wrapperClassName?: string;
};

const PercentInput = ({
  classNames,
  label,
  name,
  handleChange,
  important,
  error,
  placeholder = "00",
  readOnly,
  values,
  wrapperClassName,
}: PercentInputProps) => {
  return (
    <div className={`flex flex-col ${wrapperClassName}`}>
      <div
        className={`autocompleteWrapper !justify-center ${classNames} ${
          error && "border-red"
        } ${readOnly && "opacity-40"} `}
      >
        <div
          className={`autocompleteLabel  ${error && "text-red"} top-[-17px]`}
        >
          {label}{" "}
          <span className="text-tomato font-extrabold text-lg h-4">
            {important ? "*" : " "}
          </span>
        </div>
        <NumericFormat
          onChange={handleChange}
          value={values}
          name={name}
          maxLength={3}
          className="autocompleteInput text-center"
          placeholder={placeholder}
        />
        <span className=" absolute left-24 top-3">%</span>
      </div>
      <p className="text-red text-xs pr-3 h-4 mt-1">{error}</p>
    </div>
  );
};

export default PercentInput;
